import Cookies from 'js-cookie'

//获取浏览器的语言
function navigatorLanguage() {
  const JsSrc = (navigator.language || navigator.browserLanguage).toLowerCase();
  let language = ''
  if (JsSrc == 'zh-cn') {// 中文
    language = 'zh'
  } else if (JsSrc == 'en') {// 英文
    language = 'en'
  } else if (JsSrc == 'ko') { // 韩文
    language = 'ko'
  } else if (JsSrc == 'zh-tw') {// 繁体
    language = 'zh_ft'
  } else {
    language = 'en'
  }
  Cookies.set('language',language)
  return language
}

const app = {
  state: {
    topNav:true,
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    language: Cookies.get('language') || navigatorLanguage()
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    SET_TOPNAV(state, boolean){
      state.topNav = boolean
    }
  },
  actions: {
    set_TopNav({ commit }, boolean){
      commit('SET_TOPNAV',boolean)
    },
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js